export default function Logo({ className = "h-9 w-9" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      style={{ filter: "drop-shadow(0 0 8px rgba(94, 234, 212, 0.55))" }}
      role="img"
      aria-label="StartX Powered logo"
    >
      <defs>
        <linearGradient id="sx-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7CF5D3" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <path
        d="M12 8h11l9 15 9-15h11L38.5 32 52 56H41l-9-15-9 15H12l13.5-24Z"
        fill="url(#sx-grad)"
      />
      <path
        d="M41 10c-11.5 6-4.5 13.5-8.5 19.5S28.5 45.5 17 53"
        stroke="#7CF5D3"
        strokeWidth="4.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
